import ajax from './ajax';

export function getFrontendDetails() {
  return ajax('/settings?SettingsSearch[module_name]=frontend&per-page=200');
}
